import { Card, CardBody } from '@/components/ui/Card'
import type { ReservationBoardCourtView } from '@/lib/venue/reservationTypes'
import { summarizeCourtSlots } from '@/lib/venue/reservationViewModel'

/**
 * 코트별 운영시간·예약 단위·완료/가능/임시 점유 건수 요약(설계 §2-4(1)·(2)) — 캘린더 화면의
 * 선택 날짜 상세와 목록 화면의 "선택 시간대 요약"이 이 컴포넌트를 공유한다(설계 §2-7 D6).
 */
export function ReservationCourtSummaryPanel({ courts }: { courts: ReservationBoardCourtView[] }) {
  if (courts.length === 0) return null

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {courts.map((court) => {
        const { completed, held } = summarizeCourtSlots(court.slots)
        const operatingHours =
          court.operatingStartTime && court.operatingEndTime
            ? `${court.operatingStartTime} ~ ${court.operatingEndTime}`
            : '운영시간 미설정'

        return (
          <Card key={court.courtId}>
            <CardBody>
              <p className="text-sm font-semibold text-ink-700">{court.courtName}</p>
              <p className="mt-1 text-xs text-slateish-600">
                {operatingHours} · 예약 단위 {court.reservationUnitMinutes}분
              </p>
              <dl className="mt-3 grid grid-cols-3 gap-2 text-center">
                <div>
                  <dt className="text-[11px] text-slateish-600">완료</dt>
                  <dd className="text-sm font-semibold text-success-500">{completed}</dd>
                </div>
                <div>
                  <dt className="text-[11px] text-slateish-600">가능</dt>
                  <dd className="text-sm font-semibold text-ink-700">{court.openSlotCount}</dd>
                </div>
                <div>
                  <dt className="text-[11px] text-slateish-600">임시 점유</dt>
                  <dd className="text-sm font-semibold text-warning-500">{held}</dd>
                </div>
              </dl>
            </CardBody>
          </Card>
        )
      })}
    </div>
  )
}
